<template>
  <div id="app">
                <b-modal ref="step3Modal" id="step3Modal" centered :title="formStep1.modalTitle">
                <p><span v-html="formStep1.modalMessage"></span></p>
                <div slot="modal-footer" class="w-100">
                  <b-btn  class="float-right" variant="primary" @click="close1">OK</b-btn>
                </div>
              </b-modal>
              
    <div id="debug" class="sidenav" v-if="debug.show">
              <a class="btn" @click="toggleNav()" > 🐞 </a>
              <div class="debug-content">
      
                  <p>Débug:</p>
                    <select class="custom-select" id="debugSelect" v-on:change="onChange(debug.selected)" v-model="debug.selected">
                      <option></option>
                      <option v-for="item in debug.options" :key="item.id" :value="item.id">{{item.text}}</option>
                    </select>
                    <pre class="text-left">
formStep1:{{formStep1}}
responseData:{{responseData}} 
user:{{user}}
                    </pre>
              </div>

    </div>

    <vue-good-wizard 
      ref="wizard"
      :steps="steps"
      :onNext="nextClicked" 
      :onBack="backClicked"
      :nextStepLabel="nextStepLabel"
      :previousStepLabel="previousStepLabel"
      :finalStepLabel="finalStepLabel"
    >
      <div slot="page1">
          <!-- <img src="./assets/logo.png">
          <h1>{{ msg }}</h1>
          <div v-for="item in items" :key="item.id">
              <h2>{{ item.title }}</h2>
              <ul class="app">
                <li class="app" v-for="link in item.links" :key="link.id">
                  <a :href="link.href" :target="link.target">{{link.text}}</a>
                </li>
              </ul>
          </div> -->
          <div class="row justify-content-md-center">
            <div class="col-md-7">
              
              <h4 class="mb-5 mt-5">Déjà candidat ou inscrit à l'Université de Limoges ?</h4>
              <hr class="mb-5s">
              
              <form id="formStep1" ref="formStep1" class="needs-validation mb-5" novalidate="">
                
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="numero">N° étudiant ou identifiant candidat</label>
                    <input id="numero"
                          v-model="formStep1.data.numero"
                          type="string"
                          maxlength="10"
                          class="form-control" 
                          placeholder="6 à 10 caractères"  
                          value="" 
                          required=""
                    >
                    <small id="numeroHelp" class="form-text text-muted">Si vous possédez déjà un numéro d'étudiant de l'Université de Limoges, merci de l'utiliser, sinon utilisez votre identifiant candidat.</small>
                    <div v-if="formStep1.error.numero" class="error">
                      {{formStep1.error.numero}}
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="date_naissance">Date de naissance</label>
                    <input id="date_naissance"
                          v-model="formStep1.data.date_naissance"
                          type="date" 
                          class="form-control"  
                          placeholder="1990-01-01" 
                          value="1990-01-01"
                          required=""
                    >
                    <div v-if="formStep1.error.date" class="error">
                      {{formStep1.error.date}}
                    </div>
                  </div>
                </div>

                
                <!-- <button class="btn btn-primary btn-lg btn-block" type="submit">Continuer</button> -->
              </form>
              <hr class="">

              <!-- Informations -->
              <b-modal v-model="formStep1.modalShow" id="formStep1Modal" ref="formStep1Modal" centered :title="formStep1.modalTitle">
                <p><span v-html="formStep1.modalMessage"></span></p>
                <div slot="modal-footer" class="w-100">
                  <b-btn  class="float-right" variant="primary" @click="formStep1.modalShow=false">OK</b-btn>
                </div>
              </b-modal>
              
              <!-- Modal pour le compteur -->
              <b-modal ref="step2Modal" id="step2Modal" centered :title="formStep1.modalTitle">
                <p><span v-html="formStep1.modalMessage"></span></p>
                <div slot="modal-footer" class="w-100">
                  <b-btn  class="float-right" variant="primary" @click="close">OK</b-btn>
                </div>
              </b-modal>
          
            </div>
          </div>
          <self-building-square-spinner v-if="loading" :animation-duration="2000" :size="30" :color="'#b51621'"/>
      </div>
      
      <div slot="page2">
        <p><span v-html="formStep1.modalMessage"></span></p>
      </div>
      
      <div slot="page3">
        <p><span v-html="formStep1.modalMessage"></span></p>
      </div>
      
      <div slot="page4">
        <p><span v-html="formStep1.modalMessage"></span></p>
      </div>
      
      <div slot="page5">
        <p><span v-html="formStep1.modalMessage"></span></p>
      </div>

    </vue-good-wizard>
  </div>
</template>

<script>
import "babel-polyfill";
import axios from 'axios';
import cfg from './config.js';
import {SelfBuildingSquareSpinner} from 'epic-spinners'

export default {
  name: 'app',
  data () {
    return {
      loading: false,
      formStep1:{
        data:{numero:"",date_naissance:""},
        error:{},
        modalShow: false,
        modalMessage: "",
        modalTitle: "",
      },
      step2Modal:{
        modalShow: false,
        modalMessage: "",
        modalTitle: "",
      },      
      url: cfg.url.test,  //cfg.url.prod
      debug: {
        show:cfg.debug,
        selected:"",
        options: cfg.debugOptions,
      },  
      responseData: [],
      user: {
        situation:0,
        nom:"",
        prenom:"",
        numero:"",
        date_naissance:"",
        ine:"",
        opi:"",
        mail_perso:"",
        mail_unilim:"",
        primoweb:"",
        validate:"",
        code_etu:"",
        url:"",
      },
      
      previousStepLabel:"Précédent",
      nextStepLabel:"Suivant",
      finalStepLabel:"Fin",
      steps: [
        {
          label: 'Identifiez-vous',
          slot: 'page1'
        },
        {
          label: 'Inscription administrative',
          slot: 'page2',
        },
        {
          label: 'Valider votre compte Unilim',
          slot: 'page3',
          options: {
            backDisabled: true, // control whether next is disabled or not
            nextDisabled: true, // control whether next is disabled or not
          },
        },
        {
          label: 'Déposer vos pièces justificatives',
          slot: 'page4',
        },
        {
          label: 'Inscription(s) complémentaire(s)',
          slot: 'page5',
        },
        
      ]
    }
  },
  methods: {
    // showModal () {
    //   this.$refs.formStep1Modal.show()
    // },
    // hideModal () {
    //   this.$refs.formStep1Modal.hide()
    // },
    close() {
        this.$refs.step2Modal.hide();
    },    
    close1() {
        this.$refs.step3Modal.hide();
    },       
    compteur: function() {
        // Get compteur
        const _this = this;
        _this.loading = true;
        axios.post('https://inscription-appli.unilim.fr/compteur.php').then(response => {
            _this.loading = false;
            _this.responseData = response.data;
            //console.log("Response.data : ", response.data, _this);
            if (_this.responseData[0].TEXTE != 'BON') {
                _this.formStep1.modalTitle = _this.responseData[0].TITRE;
                _this.formStep1.modalMessage    = _this.responseData[0].TEXTE;
                _this.$refs.step2Modal.show();
                _this.$refs.wizard.currentStep = 0;
            }
        });
        return false;
    },
    nextClicked(currentPage) {
      const _this = this;
      _this.loading = false

      _this.formStep1.error = {};
      // Verify + New user
      if (_this.validNum(_this.formStep1.data.numero)){
        _this.user.numero = _this.formStep1.data.numero;
      } else {
        //_this.formStep1.error.push({numero:"Numéro invalide"});
        _this.formStep1.error.numero = "Numéro invalide";
      }
      if (_this.validDate(_this.formStep1.data.date_naissance)) {
          _this.user.date_naissance = _this.formStep1.data.date_naissance; 
      } else {
        _this.formStep1.error.date = "Date invalide";
      }
      
      // Debug étapes
      if (cfg.debug) {
        var etape = parseInt(_this.user.numero);
        if(typeof(etape) == "number" && etape <= 4){
          console.log(etape)
          _this.$refs.wizard.currentStep = etape-1;
          _this.$refs.wizard.goNext(true);
        }
      }

      if (currentPage == 0 && Object.keys(_this.formStep1.error).length === 0 ) {
        _this.loading = true
        // Search user
        axios.post('https://inscription-appli.unilim.fr/traitement.php', _this.user)
        .then(response => {
            _this.loading = false
            //console.log("Response.data : ", response.data, _this);
            _this.responseData = response.data;
            // Set user infos
            _this.user.situation  = _this.responseData[0].COD_SITUATION;
            
            _this.user.nom                  = _this.capitalize(_this.responseData[0].NOM) || null;
            _this.user.prenom               = _this.capitalize(_this.responseData[0].PRENOM) || null;
            _this.user.code_etu             = _this.responseData[0].CODE_ETU || null;
            _this.formStep1.modalMessage    = _this.responseData[0].TEXTE;
          

            // Code 0 //-----------------------------------------------------------
            if (_this.user.situation == 0 ) {
              // SCOLARITÉ  - Non connu
              _this.formStep1.modalTitle = "Un problème sur votre inscription";
              _this.$refs.formStep1Modal.show();
              _this.$refs.wizard.currentStep = _this.user.situation;
            }

            // Code 1 //-----------------------------------------------------------
            if (_this.user.situation == 1 ) {
                _this.user.url = ' ';
                _this.$refs.wizard.goNext(false);
                //_this.$refs.wizard.goBack(false);
                _this.$refs.wizard.currentStep = 1;
            }

            // Code 2 //-----------------------------------------------------------
            if (_this.user.situation == 2 ) {
              // PRIMO WEB - connu non inscrit
              _this.user.url = _this.url.primo+"?codIndOpi="+_this.user.opi+"&datNai="+_this.user.datenai || null; //?codIndOpi=EC7WMXG520&datNai=07081997
              _this.$refs.wizard.currentStep = 0;
              _this.$refs.wizard.goNext(true);
            }

            // Code 3 //-----------------------------------------------------------
            if (_this.user.situation == 3 ) {
                _this.user.url = ' ';
                _this.$refs.wizard.goNext(false);
                //_this.$refs.wizard.goBack(false);
                _this.$refs.wizard.currentStep = 2;
            }

            // Code 4 //-----------------------------------------------------------
            if (_this.user.situation == 4 ) {
                _this.user.url = ' ';
                _this.$refs.wizard.goNext(false);
                //_this.$refs.wizard.goBack(false);
                _this.$refs.wizard.currentStep = 3;
            }

            // Code 5 //-----------------------------------------------------------
            if (_this.user.situation == 5 ) {
              // Connu inscrit
              _this.user.validate = _this.url.validate;
              _this.$refs.wizard.currentStep = 2;
              _this.$refs.wizard.goNext(true);
            }

            // Code 6 //-----------------------------------------------------------
            if (_this.user.situation == 6 ) {
              // Connu inscrit
              _this.user.validate = _this.url.validate;
              _this.$refs.wizard.currentStep = 2;
              _this.$refs.wizard.goNext(true);
            }
            
        })
        .catch(e => {
          _this.errors.push(e)
        });
        return false;
      }
      return false; //return false if you want to prevent moving to next page
    },
    backClicked:function(currentPage) {
        console.log('back clicked', currentPage);
        if (currentPage == 2) { return false; }
        if (currentPage == 1) { return false; }
        return true;
    },
    validNum:function(numero) {
      return numero.length>=6 && numero.length<=10;
    },
    validDate:function(date) {
      var re = /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])$/ ;
      return re.test(date);
    },
    onChange:function(id){
      const _this = this;
      // init
      _this.$refs.wizard.currentStep = 1;
      _this.$refs.wizard.goBack(true);
      _this.loading = false

      if (id ===""){
        _this.formStep1.data.numero="";
        _this.formStep1.data.date_naissance="";
      } else {
        _this.formStep1.data.numero=this.debug.options[id].numero;
        _this.formStep1.data.date_naissance=this.debug.options[id].date_naissance;
      }
      _this.user = {};
      _this.responseData = [];
      _this.formStep1.error = {};

    },
    capitalize:function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    toggleNav:function(){
      
      if (document.getElementById("debug").style.width != "20px") {
        document.getElementById("debug").style.width = "20px";
        document.getElementById("mon_contenu").style.paddingLeft = "20px";
        document.getElementById("debug").style.backgroundColor = "#ffffff";
      } else {
        document.getElementById("debug").style.width = "500px";
        document.getElementById("mon_contenu").style.paddingLeft = "500px";
        document.getElementById("debug").style.backgroundColor = "#f6f6f6";
      }
      
    }
  },
  created: function() {
    this.compteur()  
  },
  components: {
    SelfBuildingSquareSpinner
  }
}
</script>

<style lang="scss">
#app{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

#debug{
  background-color :#f6f6f6;
  padding:20px;
  width:500px;
}

h1, h2 {
  font-weight: normal;
}

ul.app {
  list-style-type: none;
  padding: 0;
}

li.app {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.wizard__body__actions a{
  background-color: #b51621 !important;
}
.wizard__step .wizard__step__indicator{
  background-color: #f8a1a7;

}
.error {
  color: red;
}
.btn-primary {
    color: #fff;
    background-color: #b51621 !important;
    border-color: #b51621 !important;
}
.wizard__body__actions a:hover{
  color: #fff !important;
}

:root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #b51621;
  --secondary: #6c757d;
  --success: #28a745;
  --info: #17a2b8;
  --warning: #ffc107;
  --danger: #dc3545;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

// The side navigation menu 
.sidenav {
    height: 100%; 
    //width: 500px; 
    position: fixed; 
    z-index: 1; 
    top: 0;
    left: 0;
    overflow-x: hidden; 
    padding-top: 60px; 
    transition: 0.5s; 
}


// Position and style the close button (top right corner) 
.sidenav .btn {
    position: absolute;
    top: 0;
    right: -13px;
    font-size: 36px;
    
}

.debug-content{
  margin-left:20px;
}


// Style page content - use this if you want to push the page content to the right when you open the side navigation 
#mon_contenu {
    transition: padding-left .5s;
    padding: 20px;
    //padding-left:500px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue